<template>
  <div class="module" :id="'module' + indice" :class="data.type == 'lista' ? 'lista' : ''">
    <InsertComponent v-if="data.type == 'insert'" :data="data" :indice="indice" :category="category" :soy-menu="menu.page == page"/>
    <ListComponent v-if="data.type == 'lista'" :data="data" :indice="indice" :category="category"/>
  </div>
</template>
<script>
import InsertComponent from './InsertComponent'
import ListComponent from './ListComponent'
export default {
  name: 'DetilsComponent',
  props: {
    data: Object,
    indice: Number,
    page: Number,
    category: String,
    menu: Object
  },
  data () {
    return {
      products: {}
    }
  },
  components: {
    InsertComponent,
    ListComponent
  }
}
</script>
<style>
.module.lista{width:100%;display:inline-block;position:relative;vertical-align:top;margin:10px 0px}
@media only screen and (min-width: 1000px) {
  .module{display:inline-block;vertical-align:middle;margin-left:10px;}
  .module.lista{width:600px;height:auto;margin:0px 20px;vertical-align:top;}
}
</style>



// WEBPACK FOOTER //
// src/components/ModuleComponent.vue